import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SomeNavigationService {

  constructor() { }

  private _backClicked: boolean = false;

  get backClicked(): boolean {
    return this._backClicked;
  }

  set backClicked(cliecked: boolean) {
    this._backClicked = cliecked;
  }
}
